export var RouteKeys;
(function (RouteKeys) {
    RouteKeys["Home"] = "/";
    RouteKeys["BoxList"] = "/list";
    RouteKeys["Details"] = "/details";
    RouteKeys["DetailsTokenTab"] = "/details/token";
    RouteKeys["DetailsDescTabPrefix"] = "/details/desc/";
    RouteKeys["DetailsDescTab"] = "/details/desc/:index";
    RouteKeys["Edit"] = "/edit";
    RouteKeys["EditDescription"] = "/edit/desc";
    RouteKeys["EditMeta"] = "/edit/meta";
    RouteKeys["Faqs"] = "/faqs";
    RouteKeys["Profile"] = "/profile";
    RouteKeys["ProfileMaskboxCollections"] = "/profile/maskbox";
    RouteKeys["ProfileOtherCollections"] = "/profile/others";
    RouteKeys["MyMaskboxes"] = "/my-maskboxes";
})(RouteKeys || (RouteKeys = {}));
